import React from 'react'
import ReactHtmlParser from "react-html-parser";

class Agency extends React.Component {

  constructor(props) {
    super(props)
    // Show CTA only on "/altavia-cosmic-a-30-ans" Route.
    this.state = {
      article: {},
      gallery: [],
      showCTA: this.props.location.pathname === "/altavia-cosmic-a-30-ans",
      isLoading: false,
      error: null,
    }
  }

  componentDidMount() {
    this.setState({isLoading: true})
    const slug = "30-ans";
    fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/wp/v2/posts?slug=${slug}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      }
    })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error("Une erreur s'est produite.")
        }
      })
      .then(articles => {
        const article = articles[0];
        // Compute photo gallery.
        const galleryField = article.acf.gallery || {};
        const computedGallery = [];
        for (let i = 1; i <= 4; ++i) {
          if (typeof galleryField[`photo_${i}`] !== "undefined" && galleryField[`photo_${i}`]) {
            computedGallery.push(galleryField[`photo_${i}`]);
          }
        }
        // Update page state.
        this.setState({
          article: article,
          gallery: computedGallery,
          isLoading: false,
        });
      })
      .catch(error => this.setState({error, isLoading: false}));
  }

  render() {
    const article = this.state.article || {};
    const gallery = this.state.gallery || [];
    const showCTA = this.state.showCTA || false;
    const fields = article.acf || {};
    const title = fields.title || "";
    const content = (showCTA ? fields.content_with_cta : fields.content_without_cta) || {};
    const button = showCTA ? fields.cta : {};

    return (
      <div className="post-article">
        {fields.video &&
        <div className="video">
          <video controls
            poster={`${process.env.PUBLIC_URL}/images/cases/videos/video-${fields.video}.jpg`}
            src={`${process.env.PUBLIC_URL}/images/cases/videos/video-${fields.video}.mp4`}>
            Vidéo {title}
          </video>
        </div>
        }
        <div className="container">
          <div className="row no-gutters">
            <div className="title col-12">
              {fields.banner_image &&
              <img alt={fields.banner_image.alt || title} className="logo" src={fields.banner_image.url}/>
              }
              <h1>{title}</h1>
              { ReactHtmlParser(content.introduction) }
            </div>
            {fields.picture &&
            <div className="col-12 col-md-6">
              <div className="post-article__content--left">
                <img alt={fields.picture.alt} src={fields.picture.url}/>
              </div>
            </div>
            }
            <div className="col-12 col-md-6">
              <div className="post-article__content--right">
                { ReactHtmlParser(content.content) }
                {article.tags &&
                <div className="post-article__tags">
                  <p>{article.tags}</p>
                </div>
                }
                {showCTA && button && button.button_text && button.button_url &&
                <div className="post-article__actions">
                  { button.text && ReactHtmlParser(button.text) }
                  <a className="button" href={button.button_url}>{button.button_text}</a>
                </div>
                }
              </div>
            </div>
            {gallery.length &&
            <div className="post-article__gallery col-12 row align-items-center center-text">
              {
                gallery.map((photo, i) => {
                  return <div className="col-12 col-md-6 col-xl-3">
                    <img alt={photo.alt || ""} src={photo.url} />
                  </div>
                })
              }
            </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Agency



// WEBPACK FOOTER //
// ./src/containers/Page30yo.jsx